import { CustomerOrderLineView } from "src/api/generated/erp/db/types/tables/customerOrderLineView.ts";
import { DocumentsOfObjectButton } from "src/components/views/documents/objectDocuments/DocumentsOfObjectButton.tsx";
import { nullableAavoObjectRef } from "src/utils/aavoObjectRefUtils.ts";
import { AavoTextField } from "src/components/common/inputFields/AavoTextField.tsx";
import i18n from "i18next";
import { CustomerOrderSummary } from "src/api/generated/erp/sales/customerOrder/service/customerOrderSummary.ts";
import { CustomerOrderLinesFilterParams } from "src/components/views/erp/sales/customerOrderLine/CustomerOrderLinesDataGrid.tsx";
import { CustomerOrderOrOfferSummaryText } from "src/components/views/erp/sales/customerOrderLine/utils/CustomerOrderOrOfferSummaryText.tsx";
import { getOnlyMember } from "src/utils/arrayUtils.ts";

export interface CustomerOrderLinesDataGridActionBarComponentsProps {
	parentLineId: number | null;
	globalSelectedRows: CustomerOrderLineView[];
	refreshData: (params?: Partial<CustomerOrderLinesFilterParams>) => Promise<unknown>;
	customerOrderSummary: CustomerOrderSummary;
}

export const CustomerOrderLinesDataGridActionBarComponents = ({
	globalSelectedRows,
	refreshData,
	parentLineId,
	customerOrderSummary,
}: CustomerOrderLinesDataGridActionBarComponentsProps) => {
	const onlySelectedRow = getOnlyMember(globalSelectedRows);
	return (
		<>
			<DocumentsOfObjectButton
				objectRef={nullableAavoObjectRef("CUSTOMER_ORDER_LINE", onlySelectedRow?.customerOrderLineId)}
			/>
			<AavoTextField label={i18n.t("search")} onSubmit={(input) => refreshData({ searchQuery: input })} />
			{parentLineId == null && (
				<CustomerOrderOrOfferSummaryText objectType={"CUSTOMER_ORDER"} summary={customerOrderSummary} />
			)}
		</>
	);
};
